import { Box, Alert } from '@mui/material';
import { Warning as WarningIcon } from '@sweep-io/sweep-design/dist/icons';
import { TeamsConnectionStatus } from '../../../reducers/integrationsReducer';
import { colors } from '@sweep-io/sweep-design';
import { TeamsConnectButton } from '../../dashboard/user-menu/TeamsConnectButton';

export const TeamsNotConnected = ({ teamsStatus }: { teamsStatus: TeamsConnectionStatus }) => {
  const getAction = () => {
    if (teamsStatus !== TeamsConnectionStatus.Connected) {
      return <TeamsConnectButton variant="flat-blue" />;
    }
  };

  return (
    <>
      <Box
        sx={{
          width: 'fit-content',
        }}
      >
        <Alert
          icon={<WarningIcon size="medium" />}
          sx={{
            background: colors.grey[100],
            fontWeight: '500',
            borderRadius: '4px',
            color: colors.night[900],
            alignItems: 'center',
            '& .MuiAlert-action': {
              padding: 0,
              margin: '0 0 0 40px',
            },
          }}
          severity="warning"
          action={getAction()}
        >
          Please connect your Microsoft Teams workspace to continue.
        </Alert>
      </Box>
    </>
  );
};
